import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AdvertContactDataType } from '@edikk-edikk/country-frontend';
import { REDUCER_ADVERT_CONTACTS_NAME } from '#advertContacts/constants';
import { StateAdvertContacts } from '#advertContacts/types';

const initialState: StateAdvertContacts = {
  isOpen: false,
  isLoaded: false,
  isLoadInProcess: false,
  contactData: null,
  contactDataList: [],
};

const sliceAdvertContacts = createSlice({
  name: REDUCER_ADVERT_CONTACTS_NAME,
  initialState,
  reducers: {
    open: (state) => {
      state.isOpen = true;
    },
    hide: (state) => {
      state.isOpen = false;
    },
    setIsLoaded: (state, action: PayloadAction<boolean>) => {
      state.isLoaded = action.payload;
    },
    setIsLoadInProcess: (state, action: PayloadAction<boolean>) => {
      state.isLoadInProcess = action.payload;
    },
    setContactData: (state, action: PayloadAction<AdvertContactDataType>) => {
      state.contactDataList.push(action.payload);
      state.contactData = action.payload;
    },
    removeContactData: (state) => {
      state.contactDataList.pop();
      state.contactData = state.contactDataList.at(-1);
    },
  },
});

const reducerAdvertContacts = sliceAdvertContacts.reducer;

const {
  open,
  hide,
  setIsLoaded,
  setIsLoadInProcess,
  setContactData,
  removeContactData,
} = sliceAdvertContacts.actions;

export {
  reducerAdvertContacts,
  open,
  hide,
  setIsLoaded,
  setIsLoadInProcess,
  setContactData,
  removeContactData,
};
